import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
	Button,
	Col,
	Drawer,
	Form,
	Input,
	Row,
	Select,
	Spin,
	TreeSelect,
} from "antd";
import PropTypes from "prop-types";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import { ObjectNumbersToEnglish } from "scripts/helpers";
import { Fragment } from "react";

const Component = ({
	data = {},
	onUpdate,
	options: { categories = [], videos = [], images = [], files = [] },
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting, visible, loading } = state;
	const { id, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));
				values.parentId = values.parentId || null;

				values = ObjectNumbersToEnglish(values);

				if (values?.images?.length)
					values.images = values.images.map(({ image }) => image);
				if (values?.files?.length)
					values.files = values.files.map(({ file }) => file);
				if (values?.videos?.length)
					values.videos = values.videos.map(({ video }) => video);

				delete values.icon;

				const action =
					hash === `#${Modals.CREATE}`
						? API.category.create(values)
						: API.category.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						handleClose();
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({
						...prevState,
						visible: true,
						loading: true,
					}));

					API.category
						.details(id)
						.then(({ data }) => {
							form.setFieldsValue({
								...data,
								parentId: data?.parent?.id,
								iconId: data?.icon?.id,
								images: data?.images.map(({ id }) => {
									return { value: id };
								}),
								videos: data?.videos.map(({ id }) => {
									return { value: id };
								}),
								files: data?.files.map(({ id }) => {
									return { value: id };
								}),
							});

							setState((prevState) => ({
								...prevState,
								loading: false,
							}));
						})
						.catch(() => {
							setState((prevState) => ({
								...prevState,
								loading: false,
							}));
						});

					form.setFieldsValue(data);
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	const footer = (
		<>
			<Button
				type="primary"
				onClick={handleSubmit}
				loading={submitting}
			>
				{Resources.confirm}
			</Button>
			<Button
				onClick={() => handleClose()}
				loading={submitting}
			>
				{Resources.cancel}
			</Button>
		</>
	);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={footer}
			onClose={() => handleClose()}
			title={
				id
					? `${Resources.edit} ${Resources.category} "${title || "-"}"`
					: `${Resources.add} ${Resources.category}`
			}
			maskClosable={false}
			open={visible}
			width={414}
		>
			{loading ? (
				<Spin className="sp-drawer-spin" />
			) : (
				<Form
					layout="vertical"
					form={form}
				>
					<Form.Item
						name="title"
						label={Resources.title}
						rules={Rules.required}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="parentId"
						label={Resources.category}
					>
						<TreeSelect
							treeData={categories}
							treeNodeFilterProp="label"
							showSearch
							allowClear
						/>
					</Form.Item>

					<Form.Item
						name="iconId"
						label={Resources.icon}
						rules={Rules.required}
					>
						<Select
							options={images}
							optionFilterProp="label"
							showSearch
						/>
					</Form.Item>

					{/* <Row gutter={[16, 8]}>
						<Form.List name="images">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Fragment key={key}>
											<Col xs={20}>
												<Form.Item
													name={[name, "image"]}
													label={Resources.image}
													rules={Rules.required}
													{...restField}
												>
													<Select
														options={images}
														optionFilterProp="label"
														showSearch
													/>
												</Form.Item>
											</Col>
											<Col xs={4}>
												<Button
													type="link"
													onClick={() => remove(name)}
													style={{
														marginTop: 32,
														padding: 0,
													}}
													block
												>
													<i className="fa fa-minus-circle" />
												</Button>
											</Col>
										</Fragment>
									))}
									<Col xs={24}>
										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
											>{`${Resources.add} ${Resources.image}`}</Button>
										</Form.Item>
									</Col>
								</>
							)}
						</Form.List>
					</Row>
					<Row gutter={[16, 8]}>
						<Form.List name="videos">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Fragment key={key}>
											<Col xs={20}>
												<Form.Item
													name={[name, "video"]}
													label={Resources.video}
													rules={Rules.required}
													{...restField}
												>
													<Select
														options={videos}
														optionFilterProp="label"
													/>
												</Form.Item>
											</Col>
											<Col xs={4}>
												<Button
													type="link"
													onClick={() => remove(name)}
													style={{
														marginTop: 32,
														padding: 0,
													}}
													block
												>
													<i className="fa fa-minus-circle" />
												</Button>
											</Col>
										</Fragment>
									))}
									<Col xs={24}>
										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
											>{`${Resources.add} ${Resources.video}`}</Button>
										</Form.Item>
									</Col>
								</>
							)}
						</Form.List>
					</Row>
					<Row gutter={[16, 8]}>
						<Form.List name="files">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Fragment key={key}>
											<Col xs={20}>
												<Form.Item
													name={[name, "file"]}
													label={Resources.file}
													rules={Rules.required}
													{...restField}
												>
													<Select
														options={files}
														optionFilterProp="label"
													/>
												</Form.Item>
											</Col>
											<Col xs={4}>
												<Button
													type="link"
													onClick={() => remove(name)}
													style={{
														marginTop: 32,
														padding: 0,
													}}
													block
												>
													<i className="fa fa-minus-circle" />
												</Button>
											</Col>
										</Fragment>
									))}
									<Col xs={24}>
										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
											>{`${Resources.add} ${Resources.file}`}</Button>
										</Form.Item>
									</Col>
								</>
							)}
						</Form.List>
					</Row> */}
				</Form>
			)}
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
